import { AspSyncRequest, AspSyncStatusResponse } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useFetchAspSyncStatus() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);
  const [syncStatus, setSyncStatus] = useState<AspSyncStatusResponse>();

  async function fetchAspSyncStatus(params: AspSyncRequest) {
    try {
      setFetching(true);
      const res = await api.fetchAspSyncStatus(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setSyncStatus(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, syncStatus, fetchAspSyncStatus };
}
